import React, { useEffect, useState } from 'react'
import { useVsgSdk } from 'alelo-logic/contexts/vsgSdkContext'
import { getAcceptedTerms, getTerms, acceptTerm } from 'alelo-logic/services/termsService'
import { removeAuthObj } from 'alelo-logic/services/common/storage'
import Loader from '../../elements/Loader'

import { Container } from './styles'

const Terms = props => {
  document.title = 'Minha Veloe | Termos'
  const vsgSdk = useVsgSdk()
  const [loading, setLoading] = useState(true)
  const [termsData, setTermsData] = useState([])

  useEffect(() => {
    const checkTermsAcceptance = async () => {
      try {
        setLoading(true)
        const acceptedTerms = await getAcceptedTerms()
        if (acceptedTerms && acceptedTerms.length > 0) {
          props.history.push('/minha-veloe/resumo')
          return
        }
        const terms = await getTerms()
        setTermsData(terms)
        setLoading(false)
      } catch (error) {
        console.error('Erro ao verificar termos:', error)
        setLoading(false)
      }
    }

    checkTermsAcceptance()
  }, [props.history])

  useEffect(() => {
    if (!loading && termsData.length > 0 && vsgSdk) {
      const termsComponent = vsgSdk.renderizarTermos({
        background: '/images/woman.png',
        title: 'Termos de uso',
        description: 'Leia e aceite os termos e políticas abaixo para prosseguir.',
        instructions: '',
        callToActionLinks: [
          {
            description: 'Termos de uso',
            url: termsData[0].url
          }
        ],
        terms: ['Li e aceito os Termos de uso.']
      })

      termsComponent.on('cancelar', () => {
        removeAuthObj()
        props.history.push('/conta/login')
      })

      termsComponent.on('confirmar', async ({ callback: action }) => {
        try {
          await acceptTerm({ tipoTermo: termsData[0].tipoTermo, versionId: termsData[0].versionId })
          action({
            success: true,
            message: 'Termos de uso aceitos com sucesso!'
          })

          props.history.push('/minha-veloe/resumo')
        } catch (error) {
          action({
            success: false,
            message: 'Erro ao aceitar os termos de uso. Tente novamente.'
          })
        }
      })
    }
  }, [loading, termsData, vsgSdk, props.history])

  if (loading) {
    return (
      <Container>
        <Loader />
      </Container>
    )
  }

  return <Container id="vsg-termos" data-testid="vsg-termos" />
}

export default Terms
